export const address = {
  completeAddress: 'Completá la dirección',
  noPostalCode: 'Completá el código postal',
  selectOneOfYourAddresses: 'Seleccioná una de tus direcciones',
  orAddANewAddress: 'O agregá una nueva dirección',
  addANewAddress: 'Agregá una nueva dirección',
  orSelectOneOfYourAddresses: 'O seleccioná una de tus direcciones',
}

export const paymentMethod = {
  actions: {
    numberInvalid: 'Número inválido',
    expiryInvalid: 'Fecha de vencimiento inválida',
    cvcInvalid: 'Código de seguridad inválido',
  },
  selectOneOfYourCards: 'Seleccioná una de tus tarjetas',
  orAddANewCard: 'O agregá una nueva tarjeta',
  addANewCard: 'Agregá una nueva tarjeta',
  orSelectOneOfYourCards: 'O seleccioná una de tus tarjetas',
}

export const review = {
  actions: {
    confirmSuccess: 'Operación realizada con éxito',
  },
  almostDone: '¡Casi terminamos!',
  comments: 'Comentarios',
  details: 'Detalles',
  payment: 'Pago',
  confirm: 'Confirmar',
  addYourAddress: 'Ingresá tu dirección',
  addYourCreditCard: 'Ingresá tu tarjeta de crédito',
  viewPrices: 'Ver Precios',
}

export const timeslot = {
  whenDoWePickItUp: '¿Cuándo lo pasamos a buscar a',
  changeAddress: 'Cambiar dirección',
  continue: 'Continuar',
  viewPrices: 'Ver Precios',
}



// WEBPACK FOOTER //
// ./src/sections/deposit/text.js